var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaesarAiLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 722,
    viewBox: "0 0 973 722",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M973 361C973 560.375 755.187 722 486.5 722C217.813 722 0 560.375 0 361C0 161.625 217.813 0 486.5 0C755.187 0 330.933 534.904 973 361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.044 365.063C462.893 549.888 736.377 694.734 489.846 696.507C243.317 698.282 41.9663 549.888 40.1176 365.063C38.2689 180.239 236.623 28.9712 483.154 27.1978C729.682 25.4245 459.194 180.239 461.044 365.063Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.312 364.579C900.956 528.859 718.73 663.353 492.304 664.981C265.876 666.61 80.9875 534.757 79.3445 370.477C77.7011 206.198 259.925 71.7025 486.353 70.0738C712.782 68.4451 897.669 200.299 899.312 364.579Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.755 287.267C234.749 142.097 414.176 60.5703 582.516 105.174C750.853 149.778 844.36 303.621 791.366 448.794C738.371 593.966 558.946 675.492 390.606 630.887C222.266 586.283 630.249 267.231 181.755 287.267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.615 369.115C549.957 233.822 415.168 84.4949 570.687 122.44C726.203 160.385 814.709 300.822 768.367 436.114C722.028 571.407 558.389 650.321 402.873 612.376C247.355 574.431 457.276 504.407 503.615 369.115Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83 299.709C269.019 179.456 418.201 110.224 561.039 145.075C703.875 179.926 786.277 305.663 745.086 425.915C703.898 546.168 554.715 615.401 411.879 580.55C269.042 545.698 186.641 419.962 227.83 299.709Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.488 388.359C704.113 504.04 585.132 586.489 455.74 572.51C326.348 558.533 235.541 453.423 252.917 337.74C270.294 222.057 389.274 139.609 518.666 153.587C648.06 167.565 397.128 455.86 721.488 388.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.589 364.082C459.372 471.418 578.451 569.689 459.573 557.893C340.697 546.098 256.665 449.521 271.883 342.185C287.103 234.848 395.807 157.398 514.683 169.194C633.562 180.99 489.809 256.747 474.589 364.082Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.691 386.601C672.165 482.006 572.687 550.565 463.504 539.73C354.319 528.895 276.775 442.771 290.302 347.366C303.828 251.961 403.306 183.404 512.488 194.238C621.673 205.073 699.217 291.196 685.691 386.601Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.611 331.465C368.006 260.328 457.44 220.812 541.367 243.208C625.291 265.602 671.93 341.427 645.532 412.567C619.136 483.706 529.702 523.222 445.778 500.826C361.851 478.429 565.189 322.933 341.611 331.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.06 372.689C525.952 306.586 459.706 232.109 536.946 252.024C614.186 271.94 657.431 341.672 633.539 407.774C609.647 473.874 527.663 511.318 450.423 491.401C373.182 471.485 478.167 438.791 502.06 372.689Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.101 336.332C386.338 277.577 461.063 244.777 532.005 263.069C602.946 281.359 643.241 343.818 622.004 402.571C600.768 461.327 526.042 494.126 455.101 475.834C384.157 457.544 343.865 395.085 365.101 336.332Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.976 397.82C590.034 446.846 531.914 477.017 474.165 465.205C416.413 453.394 380.898 404.078 394.84 355.049C408.782 306.022 466.901 275.852 524.651 287.663C582.403 299.472 453.811 412.36 603.976 397.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.653 376.316C481.126 421.845 529.779 469.485 476.665 459.084C423.555 448.683 390.654 403.344 403.178 357.812C415.706 312.281 468.918 283.804 522.031 294.204C575.142 304.605 506.178 330.784 493.653 376.316Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.887 395.459C576.751 435.93 528.181 460.993 479.398 451.439C430.618 441.888 400.098 401.336 411.231 360.868C422.367 320.398 470.938 295.334 519.721 304.888C568.501 314.439 599.02 354.991 587.887 395.459Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.973 349.741C455.158 319.366 498.623 307.111 534.055 322.367C569.488 337.625 583.469 374.615 565.285 404.989C547.098 435.364 503.632 447.618 468.2 432.363C432.767 417.105 537.506 359.705 436.973 349.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.857 378.191C521.471 349.93 498.617 312.333 531.289 326.061C563.961 339.791 576.978 373.83 560.363 402.092C543.749 430.355 503.793 442.137 471.122 428.407C438.45 414.68 488.24 406.455 504.857 378.191Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.017 353.379C461.785 328.258 498.083 318.117 528.09 330.724C558.098 343.334 570.452 373.919 555.685 399.04C540.917 424.162 504.619 434.303 474.612 421.696C444.602 409.086 432.247 378.501 447.017 353.379Z",
    fill: "#9B6E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.812 372.559C546.365 394.92 527.604 414.044 502.908 415.277C478.212 416.51 456.934 399.384 455.381 377.026C453.828 354.665 472.589 335.541 497.288 334.308C521.983 333.075 487.153 395.008 544.812 372.559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.788 375.363C499.398 396.083 525.663 411.072 503.016 412.401C480.371 413.732 460.71 398.014 459.1 377.297C457.491 356.577 474.544 338.702 497.192 337.373C519.837 336.042 496.179 354.646 497.788 375.363Z",
    fill: "#7A1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.069 373.298C539.497 391.715 523.796 407.635 502.999 408.856C482.198 410.077 464.178 396.138 462.749 377.724C461.318 359.307 477.019 343.389 497.82 342.166C518.617 340.945 536.638 354.883 538.069 373.298Z",
    fill: "#9B6E3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 973,
    height: 722,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaesarAiLogo2);
export default __webpack_public_path__ + "static/media/CaesarAILogo 2.d756da1f7fc451514baf8404f922ae26.svg";
export { ForwardRef as ReactComponent };